import { render, staticRenderFns } from "./RelatedSecurities.vue?vue&type=template&id=63a56e51&scoped=true&"
import script from "./RelatedSecurities.vue?vue&type=script&lang=js&"
export * from "./RelatedSecurities.vue?vue&type=script&lang=js&"
import style0 from "./RelatedSecurities.vue?vue&type=style&index=0&id=63a56e51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a56e51",
  null
  
)

export default component.exports